export default __webpack_public_path__ + "static/HNH-4e787c2a1713e2f47ba804ee38920b90.png";